import React from "react";
import { Link } from "react-router-dom";
import { Logo } from "@/components/Shared";
import { useI18n } from "@/context/I18nContext";

const SIDE_IMG = "https://images.unsplash.com/photo-1637430308606-86576d8fef3c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBmaXRuZXNzJTIwc3R1ZGlvJTIwZGFya3xlbnwwfHx8fDE3ODk5Njc1NTN8MA&ixlib=rb-4.1.0&q=85";

export default function AuthLayout({ title, subtitle, children }) {
  const { lang, setLang } = useI18n();
  return (
    <div className="grid min-h-[100dvh] lg:grid-cols-2">
      <div className="relative hidden overflow-hidden lg:block">
        <img src={SIDE_IMG} alt="" className="h-full w-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-black/50" />
        <div className="absolute bottom-0 left-0 p-12 text-white">
          <h2 className="max-w-md font-display text-3xl font-bold tracking-tight">
            {lang === "id" ? "Dari squat pertama hingga transformasi jangka panjang." : "From first squat to long-term transformation."}
          </h2>
          <p className="mt-3 max-w-sm text-white/70">
            {lang === "id" ? "Pendamping harian yang elegan untuk latihan & komposisi tubuh." : "Your elegant daily companion for training & body composition."}
          </p>
        </div>
      </div>
      <div className="relative flex flex-col px-6 pb-[calc(2rem+env(safe-area-inset-bottom))] pt-[calc(1.5rem+env(safe-area-inset-top))] sm:px-10 sm:py-8">
        {/* Mobile ambient brand glow */}
        <div className="pointer-events-none absolute -top-28 left-1/2 h-64 w-64 -translate-x-1/2 rounded-full bg-primary/20 blur-3xl lg:hidden" />
        <div className="relative flex items-center justify-between">
          <Link to="/"><Logo /></Link>
          <button onClick={() => setLang(lang === "id" ? "en" : "id")}
            className="rounded-lg border px-2.5 py-1.5 text-xs font-semibold transition-colors hover:bg-accent" data-testid="auth-lang-toggle">
            {lang === "id" ? "EN" : "ID"}
          </button>
        </div>
        <div className="relative flex flex-1 items-center justify-center py-8">
          <div className="w-full max-w-sm slide-up">
            <h1 className="font-display text-3xl font-bold tracking-tight sm:text-4xl">{title}</h1>
            {subtitle && <p className="mt-2 text-sm text-muted-foreground">{subtitle}</p>}
            <div className="mt-8">{children}</div>
          </div>
        </div>
      </div>
    </div>
  );
}
